import { UiAvatarComponent } from '@/ui/avatar/ui-avatar';
import { UiButtonComponent } from '@/ui/button/ui-button';
import { UiChipComponent } from '@/ui/chip/ui-chip';
import { UiSectionActionsDirective } from '@/ui/section/section-actions/ui-section-actions';
import { UiSectionContentComponent } from '@/ui/section/section-content/ui-section-content';
import { UiSectionComponent } from '@/ui/section/ui-section';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SvgIconComponent } from 'angular-svg-icon';
import { DeveloperHelperComponent } from '../../../../../components/developer-helper/developer-helper';
import { HelpButtonComponent } from '../../../../../components/help-button/help-button';
import { LoadingAndErrorComponent } from '../../../../../components/loading-and-error/loading-and-error';
import type {
    Subtitle,
    SummaryActionElement,
    SummaryListElement,
    SummaryNoData
} from '../../../../../interfaces/SummaryListElement.interface';
import { SharedUiColorPalettePipe } from '../../../../../libs/shared/ui/theming/lib/colors/shared-ui-color-palette.pipe';
import { AsyncFallbackPipe } from '../../../../../pipes/async-fallback.pipe';
import { HasRightPipe } from '../../../../../pipes/has-right.pipe';
import { OldDataSourceCode } from '../../../../../services/developer-helper.service';

/**
 * @DEPRECATED
 * ONLY USE IN widget-building-action-summary. Do not use it again please....
 */
@Component({
    styleUrls: ['./summary-card.scss'],
    selector: 'summary-card',
    templateUrl: 'summary-card.html',
    imports: [
        UiSectionComponent,
        UiSectionActionsDirective,
        HelpButtonComponent,
        UiButtonComponent,
        UiSectionContentComponent,
        DeveloperHelperComponent,
        UiAvatarComponent,
        UiChipComponent,
        SvgIconComponent,
        LoadingAndErrorComponent,
        AsyncFallbackPipe,
        HasRightPipe,
        TranslatePipe,
        SharedUiColorPalettePipe
    ]
})
export class SummaryCardComponent {
    private _summaryList!: SummaryListElement[];

    @Input()
    cardTitle: string = 'GENERIC.ABOUT';
    @Input()
    action!: SummaryActionElement;
    @Input()
    noDataMessage!: SummaryNoData;
    @Input()
    rightNeeded: string = '';
    @Input()
    helpLink!: string;
    @Input()
    isLoading: boolean = false;
    @Input()
    hasError: boolean = false;

    @Input()
    set summaryList(summaryList: SummaryListElement[]) {
        this._summaryList = summaryList;
    }

    get summaryList(): SummaryListElement[] {
        return this._summaryList;
    }

    @Output() actionClicked = new EventEmitter<void>();

    OldDataSourceCode = OldDataSourceCode;

    actionClick(action: SummaryActionElement) {
        action.click();
    }

    subtitleToString(subtitle: Subtitle[]): string {
        if (subtitle.length > 0) {
            return subtitle
                .map(sub => {
                    return sub.text;
                })
                .join(' - ');
        }
        return '';
    }
}
